import { io } from "socket.io-client";
import { store } from "../store/store";
import { logoutUser } from "../store/userSlice";
import { dispatchSessionExpired } from "../Components/Common/SessionExpiredModal";

const URL = process.env.REACT_APP_SOCKET_URL;

let socketInstance = null;

function createSocket() {
  const token = localStorage.getItem("mamaketUserToken");

  const socketOptions = {
    transportOptions: {
      polling: {
        extraHeaders: {
          Authorization: `Bearer ${token}`,
        },
      },
    },
    reconnection: true,
  };

  const socket = io(URL, socketOptions);

  socket.on("connect", () => {});

  socket.on("exception", (err) => {
    if (err.message === "Invalid Bearer token.") {
      socketInstance = null;
      socket.disconnect();
      localStorage.removeItem("mamaketUserToken");
      localStorage.removeItem("tokenExpiresIn");
      store.dispatch(logoutUser());
      dispatchSessionExpired();
    }
  });

  socket.on("connect_error", () => {});

  return socket;
}

/**
 * Returns the current socket instance. Creates it on first call using the
 * token in localStorage, so the socket is always created with up-to-date auth.
 */
export function getSocket() {
  if (!socketInstance) {
    socketInstance = createSocket();
  }
  return socketInstance;
}

/**
 * Disconnects the current socket and clears the instance. Call after login
 * so the next getSocket() creates a new connection with the new token.
 */
export function resetSocket() {
  if (socketInstance) {
    socketInstance.disconnect();
    socketInstance = null;
  }
}

// Legacy export for code that calls initializeSocket()
export const initializeSocket = createSocket;

/**
 * Default export: proxy that forwards to getSocket(). Socket is created on
 * first use (with current token), not at module load.
 */
const socketProxy = new Proxy(
  {},
  {
    get(_, prop) {
      return getSocket()[prop];
    },
  }
);

export default socketProxy;
